import { Component } from '@angular/core';

import { ContentQuestionModel } from 'app/teacher/activities/models/content-question-model';
import { BaseEnhancedReportComponent } from '../base-enhanced-report.component';

@Component({
  selector: 'kh-question-rationale',
  styleUrls: ['./question-rationale.component.less'],
  templateUrl: './question-rationale.component.html',
  standalone: false
})
export class QuestionRationaleComponent extends BaseEnhancedReportComponent {
  public question!: ContentQuestionModel;
}
